import type { RowField } from "@/lib/refused-rows";
import { refusedText as text, refusedWords as words } from "./refused-rows-copy";

/** One typed control per field of a row's contract, each labelled by its field. */
export function RowFields({ fields, values, others = [], onChange }: {
  fields: readonly RowField[]; values: Record<string, string>; others?: string[]; onChange: (name: string, value: string) => void;
}) {
  return <div className="grid gap-3">
    {fields.map((f) => <label key={f.name} className="grid gap-1">{text.field(f.name)}
      {f.type === "choice" ? <select value={values[f.name] ?? ""} onChange={(e) => onChange(f.name, e.target.value)}>
        <option value="">{words.notGiven}</option>
        {f.options?.map((option) => <option key={option} value={option}>{text.option(option)}</option>)}
      </select>
        : <input type={f.type === "date" ? "date" : "text"} inputMode={f.type === "integer" ? "numeric" : f.type === "decimal" ? "decimal" : undefined}
          required={f.required} value={values[f.name] ?? ""} onChange={(e) => onChange(f.name, e.target.value)} />}
    </label>)}
    {others.length > 0 && <fieldset className="grid gap-2">
      <legend>{words.otherFields}</legend>
      <p className="text-muted-foreground">{words.otherFieldsNote}</p>
      {others.map((name) => <label key={name} className="grid gap-1">{name}
        <input value={values[name] ?? ""} onChange={(e) => onChange(name, e.target.value)} /></label>)}
    </fieldset>}
  </div>;
}
